module.exports = __webpack_public_path__ + "static/media/mic-icon.e4792719.svg";